import './bootstrap/bootstrap'

// Shido plugins
import dimentions from '../../../node_modules/shido.dimentions.js/src/dimentions.js'
import forms from '../../../node_modules/shido.forms.js/src/forms.js'

// plugins
import './components/prism'

// app
// require('../../../node_modules/...')
import FollowmeBars from './components/followme-bars'
import MobileNav from './components/mobile-nav'
import Tabs from './components/tabs'


// Initializers
const docReady = () => {
  new dimentions().init()
  new forms().init()

  FollowmeBars()
  MobileNav()
  Tabs()
}

const winLoad = () => {
  // ...
}

const docReadyWinload = () => {
  // ...
}

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener('DOMContentLoaded', () => {
  docReady()
  docReadyWinload()
}, false)
window.addEventListener('load', () => {
  winLoad()
  docReadyWinload()
}, false )
// ---
// ---
